import { render, staticRenderFns } from "./HouseholdNotes.vue?vue&type=template&id=5e59102f&scoped=true&"
import script from "./HouseholdNotes.vue?vue&type=script&lang=js&"
export * from "./HouseholdNotes.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdNotes.vue?vue&type=style&index=0&id=5e59102f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e59102f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow,VSpacer,VTextarea})
